export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getResolutionVoteByMandateAndResolution: state => (mandateId, meetingResolutionId) => {
      return Object.values(state.data).find(item => {
        return (
          item.mandate_id == mandateId && item.meeting_has_resolution_id == meetingResolutionId
        );
      });
    },
    getResolutionVotesByMandate: state => mandateId => {
      return Object.values(state.data).filter(item => {
        return item.mandate_id == mandateId;
      });
    },
    getResolutionVotesByResolution: state => meetingResolutionId => {
      return Object.values(state.data).filter(item => {
        return item.meeting_has_resolution_id == meetingResolutionId;
      });
    },
  },
};
